module.exports = __webpack_public_path__ + "img/Grins.09cff599.jpg";